import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clearAll(event) {
    event.preventDefault()
    Turbo.visit('/auctions', { action: 'replace' })
  }
}